import { compose } from 'redux'
import { connect } from 'react-redux'
import reduxForm from 'components/common/hoc/withFormErrorFocus'
import ChangePasswordForm from './ChangePasswordForm'
import validate from './validate'
import { CHANGE_PASSWORD_FORM } from './constants'
import { getChangePasswordFormValues, isNewPasswordDirty, isNewPasswordActive } from './selectors'

export default compose(
  connect(
    state => ({
      formValues: getChangePasswordFormValues(state),
      isNewPasswordDirty: isNewPasswordDirty(state),
      isNewPasswordActive: isNewPasswordActive(state)
    })
  ),
  reduxForm({
    form: CHANGE_PASSWORD_FORM,
    validate
  })
)(ChangePasswordForm)
